import { render, staticRenderFns } from "./OrganizeLocationList.vue?vue&type=template&id=2a7725c8&scoped=true&"
import script from "./OrganizeLocationList.vue?vue&type=script&lang=js&"
export * from "./OrganizeLocationList.vue?vue&type=script&lang=js&"
import style0 from "./OrganizeLocationList.vue?vue&type=style&index=0&id=2a7725c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7725c8",
  null
  
)

export default component.exports